import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as firebase from 'firebase';
import axios from 'axios';
import userStore from '../../stores/UserStore';

function sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
        if ((new Date().getTime() - start) > milliseconds) {
            break;
        }
    }
}


/**
 * gets sessionid props from MarketOrders
 * this component checks (StartSim/ready) and conditionally renders the start button accordingly
 */
class StartButton extends Component {

    constructor(props) {
        //console.log("StartButton constructor");
        super(props);
        this.state = {
            isPaused: true,
            ready: false,
            canStart: true,
            clicked: false,
            serverReady: false,
            serverIP: ''
        };
        this.start = this.start.bind(this);
        this.pause = this.pause.bind(this);
        this.leaveGame = this.leaveGame.bind(this);
    }

    /**
     * Removes 90% of starting orderbook, used to simulate a bad market
     */
    // async pruneOrderbookKeys() {
    //     let orderbookRef = this.props.db.child("Sessions").child(this.props.sessionid).child("ImportantData").child("SessionData").child("orderbook");
    //     orderbookRef.once('value', snapshot => {
    //         const data = snapshot.val();
    //         if (!data) return;

    //         const keys = Object.keys(data);

    //         // Calculate cutoff for 90%
    //         const cutoff = Math.floor(keys.length * 0.9);
    //         const shuffledKeys = keys.sort(() => Math.random() - 0.5);

    //         // Take the first 90% of keys
    //         const toDelete = shuffledKeys.slice(0, cutoff);

    //         // Build a multi-path update for deletion
    //         const updates = {};
    //         toDelete.forEach(key => {
    //         updates[key] = null;
    //         });

    //         orderbookRef.update(updates)
    //         .then(() => console.log(`Deleted ${toDelete.length} of ${keys.length} keys (first 90%)`))
    //         .catch(err => console.error("Error deleting keys:", err));
    //     });
    //     }


    /**
     * deals with starting and restarting a session
     */
    async start() {
        console.log("StartButton start");
        console.log("Testing prune", this.props.solo);
        // if (this.props.solo){
        //     console.log("Testing prune Pruning orderbook");
        //     await this.pruneOrderbookKeys();
        // }
        const simStateRef = this.props.db.child("Sessions").child(this.props.sessionid).child('StartSim');
        simStateRef.child("Trigger").set(true);
        simStateRef.child("State").set("Running");
        /*let that = this;
        axios.get(`http://${this.state.serverIP}/run/${this.props.institution}/${this.props.sessionid}`).then(
          (res)=>{
            console.log("response:",res);
            that.setState({
                isPaused: false,
                clicked: true
            })
        });*/
        //console.log("true");
    }

    /**
     * deals with pausing a session
     */
    pause() {
        const simStateRef = this.props.db.child("Sessions").child(this.props.sessionid).child('StartSim');

        let isPaused = true;
        let continueStepping = true;
        let stepCounter = 0;

        simStateRef.update({
            "pauseGame": {
                "isPaused": isPaused,
                "stepCounter": stepCounter,
                "continueStepping" : continueStepping
            }
        });

        while (isPaused) {
            if(confirm("Press ok to continue steping\nSteps: " + stepCounter)){
                stepCounter++;
                continueStepping = false;
            }else{
                isPaused = false;
                stepCounter = 0;
                continueStepping = true;
            }

            simStateRef.update({
                "pauseGame": {
                    "isPaused": isPaused,
                    "stepCounter": stepCounter,
                    "continueStepping" : continueStepping
                }
            });
        }
        //console.log("Changing state of running to 'Paused'");
        // simStateRef.child("running").remove().then(function () {
        //     simStateRef.child("start").set(false);
        // }).then(function () {
        //     simStateRef.child("State").set("Paused");
        // });
    }

    leaveGame() {
        let userRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Users").child(userStore.uid).child("didUserLeave");
        userRef.set({ "didUserLeave": true });
        history.back();
    }

    componentDidMount() {
        //console.log("StartButton componentDidMount");
        //console.log(this.props);
        var that = this;

        this.creatorRef = this.props.db.child("PlayableSessions").child(this.props.sessionid).child("Creator");
        this.serverRef = this.props.db.parent.child('servers').child(this.props.institution).child(this.props.sessionid);
        this.serverRef.on("value", snap => {
            let data = snap.val();
            if (!data) {
                console.log("nothing yet");
                return;
            }
            console.log("READING SERVER DATA", data);
            if (data.hasOwnProperty("status")) {
                let status = data.status;
                if (status == "ready") {
                    that.setState({
                        serverReady: true
                    });
                }
            }
        });
        this.creatorRef.once("value").then(snap => {
            if (this.props.uid === snap.val()) {
                //console.log(this.props.uid, snap.val())
                this.setState({
                    canStart: true
                })
            } else {
                this.setState({
                    canStart: false
                })
            }
        });

        this.buttonStateRef = this.props.db.child("Sessions").child(this.props.sessionid).child('StartSim').child('Ready');
        this.buttonStateRef.on('value', snap => {
            if (snap.val()) {
                this.setState({
                    isPaused: false,
                    ready: true
                })
            }
        })


    }

    componentWillUnmount() {
        //console.log("StartButton componentWillUnmount");
        this.buttonStateRef.off();
        this.serverRef.off();
        //console.log("Unmounting");
        this.setState({
            isPaused: false,
            ready: true
        });
    }

    render() {
        return (
            <div>
                <button
                    onClick={this.start}
                    className={`button-default button-red start-button ${!this.props.isReady && this.state.clicked ? 'waiting' : ''}`}
                    disabled={!(this.state.ready && this.state.canStart && this.state.serverReady) || (this.props.isReady && this.state.serverReady)}>
                    Start
                </button>
                {this.state.canStart &&
                  <button
                      className='button-default toggle-controls'
                      onClick={this.props.toggleControls}>
                      Toggle Controls
                  </button>
                }
                {!this.state.canStart &&
                  <button
                      className='button-default'
                      onClick={this.leaveGame}>
                      Leave Game
                  </button>
                }
            </div>
        );
    }
}

StartButton.propTypes = {
    sessionid: PropTypes.string
};

export default StartButton;



// WEBPACK FOOTER //
// ./src/components/Orderbook/Buttons.js